import React from 'react';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';

/**
 * Renders MUI Icon button to remove product setting.
 * @returns {React.FC}
 */

const ProductItemActions = ({ deleteProductItem }) => (
  <IconButton size="small" onClick={deleteProductItem}>
    <Tooltip title="Delete product setting">
      <DeleteIcon />
    </Tooltip>
  </IconButton>
);

export default ProductItemActions;

ProductItemActions.propTypes = {
  deleteProductItem: PropTypes.func.isRequired
};
